import React from "react";

import ReactModal from "react-modal";

export const defaultModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: 0,
    borderRadius: "1rem",
    padding: 0,
    // width: "500px",
    maxWidth: "92vw",
    overflow: "hidden",
    boxShadow: "none",
  },
  overlay: {
    zIndex: 30,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100vw",
    height: "100vh",
  },
};

// ReactModal.setAppElement("#root");

export const Modal = ({ isOpen, onClose, style, ...rest }) => (
  <ReactModal
    isOpen={isOpen}
    onRequestClose={onClose}
    style={{
      content: { ...defaultModalStyles.content, ...style?.content },
      overlay: { ...defaultModalStyles.overlay, ...style?.overlay },
    }}
    {...rest}
  />
);
